module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/159-cambodia-c14c8800978b03d7ef6e057b3fef7c83.svg";